import { render, staticRenderFns } from "./RateAbout.vue?vue&type=template&id=1394b934"
import script from "./RateAbout.vue?vue&type=script&lang=ts"
export * from "./RateAbout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseImg: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseImg.vue').default})
